import cssVariables from 'tfs.css-variables'

export default {
  icon: {
    fontSize: '1rem',
    color: cssVariables.colorGrayD,
    display: 'flex',

    '&::before': {
      animation: 'spin 1s linear',
      animationIterationCount: 'infinite',
      transformOrigin: 'center',
    },
  },

  '@keyframes spin': {
    '100%': {
      webkitTransform: 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },
}
